import { render, staticRenderFns } from "./NovidadesPage.vue?vue&type=template&id=1c5e28bf&scoped=true"
import script from "./NovidadesPage.vue?vue&type=script&lang=js"
export * from "./NovidadesPage.vue?vue&type=script&lang=js"
import style0 from "./NovidadesPage.vue?vue&type=style&index=0&id=1c5e28bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e28bf",
  null
  
)

export default component.exports